var map = {
	"./animator.ts": 8747,
	"./body.ts": 9635,
	"./button.ts": 4345,
	"./camera.ts": 1301,
	"./nineSlice.ts": 5859,
	"./script.ts": 6898,
	"./shape.ts": 5571,
	"./sprite.ts": 8000,
	"./text.ts": 1081,
	"./textAnimation.ts": 8701,
	"./tilingSprite.ts": 2460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9225;